import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Card,
  Alert,
} from "react-bootstrap";
import ClickBack from "../../components/buttons/ClickBack";
import { GetOneUser, saveUserData, GetEFactureEligibilite } from "./dataService";
import { diagnostiquerSiret } from "../../utilities";
import moment from "moment";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import ConfirmationModal from "../../components/modal/ConfirmationModal";
import OkModal from "../../components/modal/OkModal";

function EditScreen() {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [actionType, setActionType] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [userGender, setUserGender] = useState("");
  const [address, setAddress] = useState("");
  const [latLong, setLatLong] = useState({ lat: undefined, lng: undefined });
  const [status, setStatus] = useState("");
  const [siret, setSiret] = useState("");
  const [societe, setSociete] = useState("");
  const [tva, setTva] = useState("");
  const [paiementEnCompte, setPaiementEnCompte] = useState(false);
  const [excluRelanceFacture, setExcluRelanceFacture] = useState(false);
  const [emailComptable, setEmailComptable] = useState("");
  const [betaNewOrderForm, setBetaNewOrderForm] = useState(false);
  const [facturationElectronique, setFacturationElectronique] = useState(false);
  const [eligibilite, setEligibilite] = useState(null);
  const [erreurSauvegarde, setErreurSauvegarde] = useState("");
  // Erreur generale d'enregistrement, affichee au-dessus du bouton : celle de la
  // facturation electronique vit dans sa carte, plus bas, et n'existe que pour
  // les entreprises.
  const [erreurEnregistrement, setErreurEnregistrement] = useState("");
  const [adresseFacturation, setAdresseFacturation] = useState("");
  const [codePostalFacturation, setCodePostalFacturation] = useState("");
  const [villeFacturation, setVilleFacturation] = useState("");
  const [isTest, setIsTest] = useState(false);
  const [showOkModal, setShowOkModal] = useState(false); // New state for OkModal
  const [userRole, setUserRole] = useState("");
  const [currentPassword, setCurrentPassword] = useState(""); // New state for current password
  const [newPassword, setNewPassword] = useState(""); // New state for new password
  const [passwordError, setPasswordError] = useState(""); // State for password error message
  const [nouveauPasswordError, setNouveauPasswordError] = useState("")// State for new password error message
  const [userConnected, setUserConnected] = useState("");
  const { id } = useParams();
  const history = useHistory();

  useEffect(() => {
    fetchData(id);
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData && userData.id) {
      setUserConnected(userData.id);
    }
  }, [id]);
  //Fonction pour la validation du Format mot de passe
  const validatePassword = (password) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
    return regex.test(password);
  };
  const fetchData = async (id) => {
    setLoading(true);
    try {
      const user = await GetOneUser(id);
      setUserRole(user?.role || "");
      setUserData(user);
      setFirstName(user?.prenom || "");
      setLastName(user?.nom || "");
      setPhoneNumber(user?.user_profil?.telephone || "");
      setEmail(user?.email || "");
      setUserGender(user?.user_adresses?.[0]?.gender || "");
      setAddress(user?.user_adresses?.[0]?.adresse || "");
      setLatLong({
        lat: user?.user_adresses?.[0]?.latitude,
        lng: user?.user_adresses?.[0]?.longitude,
      });
      setStatus(user?.status === 1 ? "Active" : "Inactive");
      setPaiementEnCompte(user?.paiement_en_compte || false);
      setExcluRelanceFacture(user?.exclu_relance_facture || false);
      setEmailComptable(user?.email_comptable || "");
      setBetaNewOrderForm(user?.beta_new_order_form || false);
      setFacturationElectronique(user?.facturation_electronique || false);

      // Meme resolution que la facture mensuelle : type 3 en priorite, sinon
      // la premiere adresse. Editer une autre ligne ne debloquerait rien.
      const adresseFacture =
        user?.user_adresses?.find((a) => a.type === 3) || user?.user_adresses?.[0];
      setAdresseFacturation(adresseFacture?.adresse || "");
      setCodePostalFacturation(adresseFacture?.codePostal || "");
      setVilleFacturation(adresseFacture?.ville || "");
      setIsTest(user?.is_test || false);
      if (user?.role === 2) {
        setSiret(user?.user_profil?.siret || "");
        setSociete(user?.user_profil?.societe || "");
        setTva(user?.user_profil?.tva || "");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userRole !== 2 || !id) return undefined;

    const minuteur = setTimeout(() => {
      GetEFactureEligibilite(id, {
        siret,
        societe,
        tva,
        adresseFacturation,
        codePostal: codePostalFacturation,
        ville: villeFacturation,
      })
        .then(setEligibilite)
        .catch((error) =>
          console.error("Erreur eligibilite facturation electronique:", error)
        );
    }, 500);

    return () => clearTimeout(minuteur);
  }, [
    id,
    userRole,
    siret,
    societe,
    tva,
    adresseFacturation,
    codePostalFacturation,
    villeFacturation,
  ]);

  const handleSaveClick = () => {
    if (currentPassword && !validatePassword(newPassword)) {
      setNouveauPasswordError(
        "Le mot de passe doit contenir au moins 8 caractères, une majuscule, un chiffre et un caractère spécial."
      );
      return;
    }
    setActionType("save");
    setShowConfirmationModal(true);
  };

  // Function to handle OkModal close
  const handleOkModalClose = () => {
    setShowOkModal(false);
    // Optionally, you can perform additional actions after OkModal is closed
  };

  // Function to handle modal exit
  const handleCloseConfirmationModal = () => {
    // If the user cancels, simply close the modal
    setShowConfirmationModal(false);
  };

  const handleSaveConfirm = async () => {
    const updatedUserData = {
      nom: lastName,
      prenom: firstName,
      email: email,
      telephone: phoneNumber,
      status: status === "Active" ? 1 : 0,
      paiement_en_compte: paiementEnCompte ? 1 : 0,
      exclu_relance_facture: excluRelanceFacture ? 1 : 0,
      email_comptable: emailComptable || null,
      beta_new_order_form: betaNewOrderForm ? 1 : 0,
      is_test: isTest ? 1 : 0,
      address: {
        name: "-",
        gender: userGender,
        adresse: address,
        latitude:
          latLong.lat !== undefined
            ? latLong.lat
            : userData.user_adresses?.[0]?.latitude || null,
        longitude:
          latLong.lng !== undefined
            ? latLong.lng
            : userData.user_adresses?.[0]?.longitude || null,
        type: "2",
      },
      id: id,
      role: userRole,
    };

    if (userRole === 2) {
      updatedUserData.facturation_electronique = facturationElectronique ? 1 : 0;
      updatedUserData.adresseFacturation = adresseFacturation;
      updatedUserData.codePostal = codePostalFacturation;
      updatedUserData.ville = villeFacturation;
      updatedUserData.siret = siret;
      updatedUserData.societe = societe;
      updatedUserData.tva = tva;
    }

    if (currentPassword && newPassword) {
      updatedUserData.current_password = currentPassword;
      updatedUserData.new_password = newPassword;
    }

    try {
      setErreurSauvegarde("");
      setErreurEnregistrement("");
      setPasswordError("");
      const reponse = await saveUserData(id, updatedUserData);
      setShowConfirmationModal(false);

      // Le serveur peut retirer la bascule si les donnees ne sont plus
      // completes : le dire ici, plutot que de laisser l'operateur croire
      // que son enregistrement a tout conserve.
      if (reponse?.data?.avertissement) {
        setErreurSauvegarde(reponse.data.avertissement);
        setFacturationElectronique(false);
        return;
      }

      history.push("/users");
    } catch (error) {
      setShowConfirmationModal(false);
      const statut = error.response?.status;
      const corps = error.response?.data;

      if (statut === 422) {
        const message = corps?.message || "";

        if (message.toLowerCase().includes("facturation")) {
          setErreurSauvegarde(message);
        } else if (typeof corps?.data === "string" && corps.data.toLowerCase().includes("password")) {
          // Le seul cas ou le serveur parle du mot de passe : il renvoie alors
          // une chaine, et non une liste d'erreurs par champ.
          setPasswordError("Le mot de passe courant est incorrect.");
        } else {
          // Les erreurs de validation par champ — email deja utilise, domaine
          // qui ne recoit pas de courrier, SIRET invalide… Elles etaient toutes
          // affichees comme « mot de passe incorrect », si bien qu'un e-mail
          // refuse semblait enregistre jusqu'au rechargement de la page.
          const parChamp = corps?.data && typeof corps.data === "object"
            ? Object.values(corps.data).flat().filter(Boolean)
            : [];
          setErreurEnregistrement(
            parChamp.length > 0 ? parChamp.join(" ") : message || "Données refusées par le serveur."
          );
        }
      } else {
        console.error("Error updating user data:", error);
        // Rien ne s'affichait : la page restait telle quelle, et l'operateur
        // croyait avoir enregistre.
        setErreurEnregistrement(
          `Enregistrement impossible (erreur ${statut || "réseau"}). Rien n'a été modifié.`
        );
      }
    }
  };

  const handleAddressChange = async (address) => {
    setAddress(address);
    try {
      const results = await geocodeByAddress(address);
      const latLng = await getLatLng(results[0]);
      setLatLong(latLng);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  if (!userData) {
    return (
      <Container>
        <p>Chargement...</p>
      </Container>
    );
  }

  return (
    <Container>
      <div className="userList">
        <p className="h6">
          Accueil / Utilisateurs / {userData.prenom} {userData.nom}
        </p>
        <Row className="pt-4 pb-2">
          <Col style={{ display: "flex", alignItems: "center" }}>
            <ClickBack editPage={true} />
            <h1 className="p-1">
              {userData.prenom} {userData.nom}
            </h1>
          </Col>
        </Row>
        {loading ? (
          <p className="lead">Chargement...</p>
        ) : (
          <Form>
            <Card className="mb-3">
              <Card.Body>
                <Card.Title className="pb-3">
                  Information personnelle
                </Card.Title>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="formCreationDate">
                      <Form.Label>Date de création</Form.Label>
                      <Form.Control
                        size="lg"
                        type="text"
                        disabled
                        value={moment(userData.created_at).format(
                          "DD/MM/YYYY , HH:MM"
                        )}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="formStatus">
                      <Form.Label>Etat</Form.Label>
                      <Form.Control
                        size="lg"
                        as="select"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="formFirstName">
                      <Form.Label>Prénom</Form.Label>
                      <Form.Control
                        size="lg"
                        type="text"
                        placeholder="Prénom"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="formLastName">
                      <Form.Label>Nom</Form.Label>
                      <Form.Control
                        size="lg"
                        type="text"
                        placeholder="Nom"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="formPhoneNumber">
                      <Form.Label>Numéro de téléphone</Form.Label>
                      <Form.Control
                        size="lg"
                        type="tel"
                        placeholder="Numéro de téléphone"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="formEmail">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        size="lg"
                        type="email"
                        placeholder="nom@exemple.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-3" controlId="formComment">
                      <Form.Label>Sexe</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        value={userGender}
                        onChange={(e) => setUserGender(e.target.value)}
                      >
                        <option value="" disabled hidden>
                          Sélectionnez le sexe
                        </option>
                        <option value="Homme">Homme</option>
                        <option value="Femme">Femme</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* Mode de paiement */}
            <Card className="mb-3">
              <Card.Body>
                <Card.Title className="pb-3">Mode de paiement</Card.Title>
                <Row>
                  <Col>
                    <Form.Check
                      type="switch"
                      id="paiementEnCompteSwitch"
                      label="Paiement en compte autorisé (facturation mensuelle)"
                      checked={paiementEnCompte}
                      onChange={(e) => setPaiementEnCompte(e.target.checked)}
                    />
                    <Form.Text className="text-muted">
                      Si activé, l'utilisateur pourra passer des commandes sans payer immédiatement. Une facture mensuelle sera générée.
                    </Form.Text>
                  </Col>
                </Row>
                {paiementEnCompte && (
                  <Row className="mt-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Email du comptable (optionnel)</Form.Label>
                        <Form.Control
                          type="email"
                          value={emailComptable}
                          onChange={(e) => setEmailComptable(e.target.value)}
                          placeholder="comptabilite@client.fr"
                        />
                        <Form.Text className="text-muted">
                          Utilisé à terme pour les relances de factures impayées, en plus du contact habituel.
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Check
                        type="switch"
                        id="betaNewOrderFormSwitch"
                        label="Formulaire de commande : fonctionnalités en test"
                        checked={betaNewOrderForm}
                        onChange={(e) => setBetaNewOrderForm(e.target.checked)}
                      />
                      <Form.Text className="text-muted">
                        Si activé, ce client voit les nouveautés du formulaire de commande avant les autres. Sans nouveauté en test, la case n'a aucun effet : tous les clients ont le même formulaire.
                      </Form.Text>
                    </Col>
                  </Row>
                )}
                {paiementEnCompte && (
                  <Row className="mt-3">
                    <Col>
                      <Form.Check
                        type="switch"
                        id="excluRelanceFactureSwitch"
                        label="Exclure des relances de facture"
                        checked={excluRelanceFacture}
                        onChange={(e) => setExcluRelanceFacture(e.target.checked)}
                      />
                      <Form.Text className="text-muted">
                        Pour les clients qui règlent systématiquement dans les délais : ils ne reçoivent aucune relance de paiement (J+30, J+35, J+40), mais continuent de recevoir le mail d'information à l'émission de chaque facture.
                      </Form.Text>
                    </Col>
                  </Row>
                )}
              </Card.Body>
            </Card>

            {/* Champ spécifique au rôle 3 (livreur) */}
            {userRole === 3 && (
              <Card className="mb-3">
                <Card.Body>
                  <Card.Title className="pb-3">Compte livreur</Card.Title>
                  <Row>
                    <Col>
                      <Form.Check
                        type="switch"
                        id="isTestSwitch"
                        label="Compte de test"
                        checked={isTest}
                        onChange={(e) => setIsTest(e.target.checked)}
                      />
                      <Form.Text className="text-muted">
                        Si activé, ce livreur n'apparaît pas dans la timeline dispatch ni dans la disponibilité proposée à l'assignation d'une commande.
                      </Form.Text>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}

            {/* Champs spécifiques pour le rôle 2 */}
            {userRole === 2 && (
              <Card className="mb-3">
                <Card.Body>
                  <Card.Title className="pb-3">
                    Informations complémentaires
                  </Card.Title>
                  <Row>
                    <Col>
                      <Form.Group className="mb-3" controlId="formSiret">
                        <Form.Label>SIRET (14 chiffres)</Form.Label>
                        <Form.Control
                          size="lg"
                          type="text"
                          placeholder="Ex : 987 734 472 00010"
                          value={siret}
                          onChange={(e) => setSiret(e.target.value)}
                        />
                        {/* Retour immédiat : sans lui, on saisit quatorze chiffres
                            sans savoir s'ils sont bons avant l'échec d'une
                            transmission, des semaines plus tard. La validation qui
                            fait foi reste celle du serveur. */}
                        {(() => {
                          const d = diagnostiquerSiret(siret);
                          if (d.etat === "absent") return null;
                          const couleur = {
                            valide: "text-success",
                            incomplet: "text-warning",
                            invalide: "text-danger",
                          }[d.etat];
                          return (
                            <Form.Text className={`${couleur} d-block mt-1`}>
                              {d.etat === "valide" ? "✓ " : "⚠ "}
                              {d.message}
                            </Form.Text>
                          );
                        })()}
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-3" controlId="formSociete">
                        <Form.Label>Société</Form.Label>
                        <Form.Control
                          size="lg"
                          type="text"
                          placeholder="Société"
                          value={societe}
                          onChange={(e) => setSociete(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group className="mb-3" controlId="formTva">
                        <Form.Label>TVA</Form.Label>
                        <Form.Control
                          size="lg"
                          type="text"
                          placeholder="TVA"
                          value={tva}
                          onChange={(e) => setTva(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}

            {/* Facturation electronique — role 2 uniquement : la reforme ne
                concerne que les operations entre assujettis. */}
            {userRole === 2 && (
              <Card className="mb-3">
                <Card.Body>
                  <Card.Title className="pb-3">
                    Facturation électronique
                  </Card.Title>

                  {erreurSauvegarde && (
                    <Alert variant="danger">{erreurSauvegarde}</Alert>
                  )}

                  <Row>
                    <Col>
                      <Form.Check
                        type="switch"
                        id="facturationElectroniqueSwitch"
                        label="Émettre les factures de ce client en facture électronique"
                        checked={facturationElectronique}
                        // On peut toujours désactiver. On ne peut activer que
                        // si les données permettent l'acheminement : sinon la
                        // facture serait rejetée à la transmission, des
                        // semaines avant qu'on ne s'en aperçoive.
                        disabled={!facturationElectronique && !eligibilite?.eligible}
                        onChange={(e) =>
                          setFacturationElectronique(e.target.checked)
                        }
                      />
                      <Form.Text className="text-muted">
                        {facturationElectronique
                          ? "Ce client ne reçoit plus de PDF par email : sa facture est transmise par la plateforme."
                          : eligibilite?.eligible
                          ? "Les données légales de ce client sont complètes, la bascule est possible."
                          : "Bascule impossible tant que les points ci-dessous ne sont pas réglés."}
                      </Form.Text>
                    </Col>
                  </Row>

                  {/* Adresse de facturation : c'est celle que porte la
                      facture mensuelle, et le back-office ne l'exposait nulle
                      part — le champ Adresse plus bas edite l'adresse de
                      livraison. Un client bloque ici n'etait donc corrigeable
                      par aucun ecran. */}
                  <Row className="mt-4">
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Adresse de facturation</Form.Label>
                        <Form.Control
                          type="text"
                          value={adresseFacturation}
                          onChange={(e) => setAdresseFacturation(e.target.value)}
                          placeholder="12 Avenue Jean Médecin"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Code postal</Form.Label>
                        <Form.Control
                          type="text"
                          value={codePostalFacturation}
                          onChange={(e) =>
                            setCodePostalFacturation(e.target.value)
                          }
                          placeholder="06000"
                          maxLength="5"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Ville</Form.Label>
                        <Form.Control
                          type="text"
                          value={villeFacturation}
                          onChange={(e) => setVilleFacturation(e.target.value)}
                          placeholder="Nice"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  {eligibilite && (
                    <Row className="mt-3">
                      <Col>
                        <ul className="list-unstyled mb-0">
                          {eligibilite.controles.map((controle) => {
                            const marque = {
                              ok: { signe: "✓", couleur: "text-success" },
                              manquant: { signe: "✗", couleur: "text-danger" },
                              invalide: { signe: "✗", couleur: "text-danger" },
                              avertissement: { signe: "⚠", couleur: "text-warning" },
                            }[controle.etat];

                            return (
                              <li key={controle.cle} className="mb-1">
                                <span className={`${marque.couleur} me-2`}>
                                  {marque.signe}
                                </span>
                                <strong>{controle.libelle}</strong>
                                <span className="text-muted"> — {controle.detail}</span>
                                {controle.suggestion && (
                                  <Button
                                    variant="link"
                                    size="sm"
                                    className="p-0 ms-2 align-baseline"
                                    onClick={() => setTva(controle.suggestion)}
                                  >
                                    utiliser {controle.suggestion}
                                  </Button>
                                )}
                              </li>
                            );
                          })}
                        </ul>
                      </Col>
                    </Row>
                  )}

                  {/* Identite de Marion : tant qu'elle n'est pas configuree,
                      aucun client ne peut basculer, quelles que soient ses
                      propres donnees. L'encart ne s'affiche que dans ce cas,
                      pour ne pas repeter une information reglee. */}
                  {eligibilite?.emetteur?.some((c) => c.etat !== "ok") && (
                    <Alert variant="warning" className="mt-3 mb-0">
                      <strong>Configuration Marion Livraison incomplète</strong>
                      <ul className="mb-0 mt-2">
                        {eligibilite.emetteur
                          .filter((c) => c.etat !== "ok")
                          .map((c) => (
                            <li key={c.cle}>
                              {c.libelle} — {c.detail}
                              {c.suggestion && ` (calculé : ${c.suggestion})`}
                            </li>
                          ))}
                      </ul>
                    </Alert>
                  )}
                </Card.Body>
              </Card>
            )}

            {/* Adresse */}
            <Card className="mb-3">
              <Card.Body>
                <Card.Title className="pb-3">Adresse</Card.Title>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="formAddress">
                      <Form.Label>Adresse</Form.Label>
                      <PlacesAutocomplete
                        value={address}
                        onChange={setAddress}
                        onSelect={handleAddressChange}
                      >
                        {({
                          getInputProps,
                          suggestions,
                          getSuggestionItemProps,
                          loading,
                        }) => (
                          <div>
                            <Form.Control
                              {...getInputProps({
                                placeholder: "Entrez votre adresse",
                              })}
                              size="lg"
                            />
                            <div>
                              {loading ? <div>Chargement...</div> : null}
                              {suggestions.map((suggestion) => {
                                const style = {
                                  backgroundColor: suggestion.active
                                    ? "#41b6e6"
                                    : "#fff",
                                };
                                return (
                                  <div
                                    {...getSuggestionItemProps(suggestion, {
                                      style,
                                    })}
                                  >
                                    {suggestion.description}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </PlacesAutocomplete>
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            {/* Password */}
            {id == userConnected && (
              <Card className="mb-3">
                <Card.Body>
                  <Card.Title className="pb-3">Mot de passe</Card.Title>
                  <Row>
                    <Col>
                      <Form.Group
                        className="mb-3"
                        controlId="formCurrentPassword"
                      >
                        <Form.Label>Mot de passe actuel</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Mot de passe actuel"
                          value={currentPassword}
                          onChange={(e) => {
                            setCurrentPassword(e.target.value);
                            setPasswordError("");
                            setNouveauPasswordError("");
                          }}
                        />
                        {passwordError && (
                          <Alert variant="danger" className="mt-2">
                            {passwordError}
                          </Alert>
                        )}
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-3" controlId="formNewPassword">
                        <Form.Label>Nouveau mot de passe</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Nouveau mot de passe"
                          value={newPassword}
                          onChange={(e) => {
                            setNewPassword(e.target.value);
                            setPasswordError("");
                          }}
                        />
                        {nouveauPasswordError && (
                          <Alert variant="danger" className="mt-2">
                            {nouveauPasswordError}
                          </Alert>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}

            {/* Boutons d'action */}
            <Row className="mt-4">
              <Col>
                {erreurEnregistrement && (
                  <Alert variant="danger">{erreurEnregistrement}</Alert>
                )}
                <Button
                  variant="primary"
                  onClick={handleSaveClick}
                  className="me-2"
                >
                  Enregistrer
                </Button>
                <Button variant="secondary" onClick={() => history.goBack()}>
                  Annuler
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </div>
      {/* Confirmation Modal */}
      <ConfirmationModal
        show={showConfirmationModal}
        onClose={handleCloseConfirmationModal}
        onConfirm={handleSaveConfirm}
        actionType={actionType}
      />
      <OkModal
        show={showOkModal}
        onClose={handleOkModalClose}
        onConfirm={handleOkModalClose}
      />
    </Container>
  );
}

export default EditScreen;
